import { useMemo } from 'react';
import ChatsMessage from './ChatsMessage';
import { Message } from '@/types/chats';
import ChatsDateSeparator from '../../common/ChatsDateSeparator';

const getMessageDayKey = (createdAt: string) => {
  const date = new Date(createdAt);

  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
};

const ChatsMessagesList = ({
  messages,
  chatTitle,
  searchQuery,
}: {
  messages: Message[];
  chatTitle?: string;
  searchQuery?: string;
}) => {
  const messagesWithDateSeparators = useMemo(() => {
    let previousDayKey: string | null = null;

    return messages.map((message) => {
      const dayKey = getMessageDayKey(message.createdAt);
      const showDateSeparator = dayKey !== previousDayKey;
      previousDayKey = dayKey;

      return { message, showDateSeparator };
    });
  }, [messages]);

  if (messages.length === 0) {
    return (
      <div className="flex flex-1 items-center justify-center px-6 py-16">
        <p className="text-center text-sm lg:text-base text-lightGray">Сообщений пока нет</p>
      </div>
    );
  }

  return (
    <div
      id="chats-messages-list"
      className="grid min-w-0 gap-3 md:mx-auto md:w-full md:max-w-3xl md:gap-2"
    >
      {messagesWithDateSeparators.map(({ message, showDateSeparator }) => (
        <div key={message.id} className="grid min-w-0 gap-3 md:gap-2">
          {showDateSeparator && <ChatsDateSeparator date={message.createdAt} />}
          <ChatsMessage message={message} chatTitle={chatTitle} searchQuery={searchQuery}>
            <ChatsMessage.Info />
            <ChatsMessage.Message />
            {(message?.images?.length ?? 0) > 0 && <ChatsMessage.Images />}
            <div className="flex min-w-0 items-center justify-between gap-2">
              <ChatsMessage.Date />
              <ChatsMessage.Reactions />
            </div>
          </ChatsMessage>
        </div>
      ))}
    </div>
  );
};

export default ChatsMessagesList;
